<template>
  <div>
    <span>{{ formattedValue }}</span>
  </div>
</template>

<script>
import typeaheads from '@/services/typeahead/typeahead.utils.js';
import jllLocalstorageManager from 'jll-localstorage-manager';

export default {
  name: 'cell-dt-typeahead-type',
  props: {
    value: { type: String, default: '' },
    config: { type: Object, default: null },
  },
  data() {
    return { formattedValue: '' };
  },
  watch: {
    value: {
      handler(newValue, oldValue) {
        if (newValue !== oldValue && newValue) {
          this.getMemoizedAutocompleteLabel(newValue);
        }
      },
      immediate: true,
    },
  },
  methods: {
    async getMemoizedAutocompleteLabel(Value) {
      const foundInLocalStorage = jllLocalstorageManager.get(`PixTypeahead-${Value}`);

      if (foundInLocalStorage) {
        this.formattedValue = foundInLocalStorage;
      } else {
        const [{ GeographyName }] = await typeaheads.getLabel(this.config.EmitEventName)({
          config: { ...this.config, Value },
        });
        this.formattedValue = GeographyName;
        jllLocalstorageManager.set(`PixTypeahead-${Value}`, GeographyName, 1000 * 3600 * 24);
      }
    },
  },
};
</script>
